import React, { useEffect, useRef } from "react"
import { useInView } from "react-intersection-observer"
import { Box } from "@theme-ui/components"

const VideoStream = ({
  videoUrl,
  customData,
  minHeight = "100%",
  aspectRatio,
}) => {
  const isNotAutoplay = customData?.autoplay === "false"
  const playerRef = useRef(null)
  const [ref, inView] = useInView({
    threshold: 0.2,
  })

  useEffect(() => {
    const video = playerRef.current
    if (video) {
      if (inView && !isNotAutoplay) {
        video.play().catch(error => {
          console.error("Error attempting to play video:", error)
        })
      } else {
        try {
          video.pause()
        } catch (error) {
          console.error("Error attempting to pause video:", error)
        }
      }
    }
  }, [inView, isNotAutoplay])

  return (
    <Box
      ref={ref}
      sx={{
        width: "100%",
        height: minHeight,
        overflow: "hidden",
        ".videoMob": {
          position: "absolute",
          inset: "0",
          minWidth: "100vw",
          minHeight: "100vh",
          overflow: "hidden",
          objectFit: "cover",
        },
      }}
    >
      <video
        ref={playerRef}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          objectPosition: "center",
          aspectRatio: aspectRatio ? aspectRatio : null,
        }}
        playsInline
        preload="auto"
        muted={!isNotAutoplay}
        loop={!isNotAutoplay}
        controls={isNotAutoplay}
        autoPlay={!isNotAutoplay}
      >
        <source src={videoUrl} type="video/mp4" />
        Il tuo browser non supporta il tag video.
      </video>
    </Box>
  )
}

export default VideoStream
